import { registerAction } from '../../Action'

const MARK_TASK_COMPLETE = 'MARK_TASK_COMPLETE'

const reducer = (state = {}, action) => {
  const subTab = [action.payload.subTab]
  const tasks = state.tasks[subTab].filter(
    (item) => Number(item.id) !== Number(action.payload.id)
  )

  return {
    ...state,
    tasks: {
      ...state.tasks,
      [subTab]: tasks,
    },
  }
}

const markTaskComplete = registerAction(MARK_TASK_COMPLETE, { reducer })

export default markTaskComplete
